import { namespaceConstantType } from '@front/common/types'

export const INSERT_SUBSCRIPTIONS: namespaceConstantType = [
  'subscription',
  'insert',
]

export const UPDATE_SUBSCRIPTION: namespaceConstantType = [
  'subscription',
  'update',
]

export const DELETE_SUBSCRIPTION: namespaceConstantType = [
  'subscription',
  'delete',
]

export const ADD_SUBSCRIPTION: namespaceConstantType = ['subscription', 'add']

export const UPSERT_SERVICE: namespaceConstantType = [
  'subscription',
  'service/upsert',
]

export const DELETE_SERVICE: namespaceConstantType = [
  'subscription',
  'service/delete',
]

export const UPSERT_ITEM: namespaceConstantType = [
  'subscription',
  'service/item/upsert',
]

export const DELETE_ITEM: namespaceConstantType = [
  'subscription',
  'service/item/delete',
]
